export const MOBILE_APPLIANCE_CODE = 'CP';
export const MOBILE_LT_CODE = 'C>';
